import { render, staticRenderFns } from "./CardCompact.vue?vue&type=template&id=5de972b8&scoped=true&"
import script from "./CardCompact.vue?vue&type=script&lang=js&"
export * from "./CardCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de972b8",
  null
  
)

export default component.exports